import request from '@/common/request'
import {
	Page,
} from '@/models'
import { Embalagem } from '@/models/Embalagem'
import { AxiosRequestConfig } from 'axios'

export const listarPorLoja = async (lojaId: string, params?: any, config?: AxiosRequestConfig): Promise<Page<Embalagem>> =>
	request.get(`/embalagens/${lojaId}`, {params, ...config})

export const criar = async (embalagem: Embalagem): Promise<Embalagem> =>
	request.post(`/embalagens`, embalagem)

export const editar = async (embalagem: Embalagem): Promise<Embalagem> =>
	request.put(`/embalagens/${embalagem.id}`, embalagem)
